import Image from 'next/image'
import React, { ComponentProps } from 'react'
import { Absolute } from '../../bases/Absolute'
import { Clickable } from '../../bases/Clickable'
import { HStack } from '../../bases/HStack'
import { Space } from '../../bases/Space'
import { Text } from '../../bases/Text'
import logo from '../../../../../public/images/logo.png'
import MetamaskLogo from '../../../../../public/images/metamaskLogo.png'
import { useTranslation } from 'react-i18next'
import { Spinner } from '../Spinner'
import { Center } from '../../bases/Center'
import ReactTooltip from 'react-tooltip'
import { MetamaskChecker } from '@/src/views/providers/MetamaskChecker'
import { DISPLAY_VERSION } from '@/src/assets/constants'

export type Props = {
  connectedWallet: string
  onClickStaking: () => void
  onClickMarketPlace: () => void
  visibleSpinner: boolean
  isLoggedIn: boolean
} & ComponentProps<typeof ContractProcessingStatus>

export const Layout: React.FC<Props> = (props) => {
  const shortWalletAddress = props.connectedWallet.replace(/^(\w{5})\w+(\w{4})$/, '$1...$2')
  const { t } = useTranslation()
  return (
    <HStack className="h-14 w-full bg-black">
      <HStack className="h-full w-full items-center bg-gradient-to-r from-gradient-headerLeft to-gradient-headerRight">
        <HStack className="relative h-full w-64 items-center justify-center">
          <Image className="h-9" src={logo} width={146} height={36} alt="logo" />
          <Absolute className="bottom-1">
            <Text
              className="text-xs font-semibold text-white"
              style={{ textShadow: '0px 0px 3px rgba(255, 255, 255, 0.7)' }}
            >
              {DISPLAY_VERSION}
            </Text>
          </Absolute>
        </HStack>
        <Space />
        {props.isLoggedIn && (
          <MetamaskChecker>
            {shortWalletAddress.length > 0 ? (
              <HStack className="items-center">
                {props.visibleSpinner ? (
                  <ContractProcessingStatus depositing={props.depositing} withdrawing={props.withdrawing} />
                ) : null}
                <Image src={MetamaskLogo} width={24} height={24} objectFit="contain" alt="" />
                <Text className="ml-2 mr-10 font-bold text-white">{shortWalletAddress}</Text>
              </HStack>
            ) : null}
          </MetamaskChecker>
        )}
        <Clickable className="flex h-full items-center justify-center px-7">
          <Text className=" font-bold text-white  opacity-40">
            {t('WorldManagerGlobalHeader.stakingLink')}
          </Text>
          <Absolute className="bottom-0.5">
            <Text className="text-xs font-semibold text-primary-textActive">{t('Common.comingSoon')}</Text>
          </Absolute>
        </Clickable>
        <Clickable
          className="flex h-full items-center justify-center px-7"
          onClick={props.onClickMarketPlace}
        >
          <Text className=" font-bold text-white hover:text-primary-textActive">
            {t('WorldManagerGlobalHeader.marketplaceLink')}
          </Text>
        </Clickable>
      </HStack>
    </HStack>
  )
}

const ContractProcessingStatus = (props: { withdrawing: Array<string>; depositing: Array<string> }) => {
  const { t } = useTranslation()
  return (
    <Center>
      <div className="p-3" data-tip data-for="tooltip">
        <Spinner size={18} visible color="#00FBEC" />
      </div>
      <ReactTooltip
        id="tooltip"
        place="bottom"
        backgroundColor="black"
        borderColor="#888"
        border
        padding="6px 10px"
      >
        <div className="text-xs text-white">
          {props.depositing.map((name, i) => (
            <HStack key={i} className="items-center">
              <Spinner size={12} visible color="#00FBEC" />
              <Text className="ml-2 text-sm text-neon-blue">
                {name} {t('WorldManagerGlobalHeader.depositing')}
              </Text>
            </HStack>
          ))}
          {props.withdrawing.map((name, i) => (
            <HStack key={i} className="items-center">
              <Spinner size={12} visible color="#00FBEC" />
              <Text className="ml-2 text-sm text-neon-blue">
                {name} {t('WorldManagerGlobalHeader.withdrawing')}
              </Text>
            </HStack>
          ))}
        </div>
      </ReactTooltip>
    </Center>
  )
}
